import * as theme from "../theme";
import { makeStyles } from "@material-ui/core/styles";
import { useRef, useState } from "react";
import ScoreBar from "../general/ScoreBar";
import QuestionProgress from "../general/QuestionProgress";

const AllInOnePage = ({ Scrollable, currentnode, allinonepage }) => {
  const mainDivRef = useRef(null);
  const initialScrollBarThickness = "0.5vw";
  const useStyles = makeStyles(theme.customMaterialUIClassForScrollBar);

  // const scrollThickness = useSelector(getQAreaScrollThickness);

  const classes = useStyles();

  const firstDivHeight = "12%";
  const secondDivHeight = "88%";
  const thirdDivHeight = `calc(100% - ${firstDivHeight} - ${secondDivHeight})`;

  const spaceBetweenScroll = "1.7vw";
  const leftRightMargin = theme.SCALES.letfRighMarginInQuestionArea;

  const [showScroll, setShowScroll] = useState(false);

  const handleShowScroll = (value) => {
    setShowScroll(value);
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: theme.COLORS.tertiary_lightbackground,
      }}
    >
      <div
        style={{
          width: "100%",
          height: firstDivHeight,
          paddingLeft: leftRightMargin,
          paddingRight: leftRightMargin,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <QuestionProgress></QuestionProgress>
      </div>
      <div
        style={{
          width: "100%",
          height: secondDivHeight,
          paddingRight: showScroll
            ? `calc(${leftRightMargin} - ${spaceBetweenScroll} - ${initialScrollBarThickness})`
            : `calc(${leftRightMargin} - ${spaceBetweenScroll})`,
          paddingLeft: leftRightMargin,
        }}
      >
        <div
          ref={mainDivRef}
          style={{
            width: "100%",
            height: "100%",
            paddingRight: spaceBetweenScroll,
            overflow: "auto",
          }}
          className={classes.responses}
        >
          <Scrollable
            currentnode={currentnode}
            allinonepage={allinonepage}
            mainDivRef={mainDivRef}
            handleShowScroll={handleShowScroll}
          ></Scrollable>
        </div>
      </div>
      <div style={{ width: "100%", height: thirdDivHeight }}></div>
    </div>
  );
};

export default AllInOnePage;
